import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserInfo } from '../helper/Context';
import AccessCodeModal from './AccessCodeModal';

/**
 * AIFeatureGate - Combined gate for AI features
 * - Free users: Shows premium upgrade popup
 * - Non-free users: Shows AI access code popup
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The page content to render
 * @param {string} props.featureName - Name of the feature being gated (for display)
 */


const AIFeatureGate = ({ children, featureName = 'this feature', requiredCode = "", featureKey = "" }) => {
  const navigate = useNavigate();
  const { userInfo } = useContext(UserInfo);
  const [hasAIAccess, setHasAIAccess] = useState(userInfo?.permissions?.[featureKey] || false);
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');

  const isFreeUser = !userInfo || userInfo.tier === 'free';
  useEffect(() => {
    if (userInfo) {
      setHasAIAccess(userInfo?.permissions?.[featureKey] || false);
    }
  }, [userInfo]);

  // Non-free user with AI access - allow through
  if (hasAIAccess) {
    return children;
  }
  else {
    return (
      <>
        <AccessCodeModal show={!hasAIAccess} onHide={() => { }}
         onAccessGranted={() => { setHasAIAccess(true) }} 
         featureName={featureName} requiredCode={requiredCode} 
         featureKey={featureKey} zIndex={990} hideCancelButton={true} overlayAlpha={0.25} />
        <div style={{ position: 'relative', minHeight: '100vh' }}>
          {/* Page content - rendered but not interactive */}
          <div style={{ pointerEvents: 'none' }}>
            {children}
          </div>
        </div>
      </>)
  };
};
export default AIFeatureGate;

